
<template>
  <div>
    <card-loading-transparent v-if="!chart_ready || loading_dash"></card-loading-transparent>
    <template v-if="chart_ready && !loading_dash">
      <v-col class="px-10">
        <div class="title">{{title}}</div>
        <v-alert v-if="!data.length" type="info" :value="true">
          Não possui dados
        </v-alert>
        <div v-if="data.length" :style="{width: false? '70vw' : ''}">
          <donut-chart ref="ct" v-if="chart_ready" :chart-data="DonutData" :options="DonutOptions"> </donut-chart>
          <!-- <donut-chart ref="ct" @click="loga" v-if="chart_ready" :chart-data="DonutData" :options="DonutOptions"> </donut-chart> -->
          <!-- <bar-chart ref="ct" v-if="chart_ready" :chart-data="chartData" :options="chartOptions"></bar-chart> -->
        </div>
      </v-col>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Vuetify from '@/plugins/vuetify';

export default {
  name: 'FailPieChart',
  components: {
    DonutChart: () => import('@/components/charts/DonutChart.vue'),
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    kind:{
      type: String,
      default: 'by_'
    },
    title:{
      type: String,
      default: 'Ranking'
    },
    text_key:{
      type: String,
      default: 'text'
    },
    value_key:{
      type: String,
      default: 'count'
    },
    max_data: {
      type: Number,
      default: 10,
    },
    loading_dash:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      DonutData:{
        datasets: [{
          data: [],// [1,2,8],
        }],
        labels: []// ['1','2','8'],
      },
      DonutOptions:{
        events: ['click', 'mousemove'],
        onClick: (e)=> {
          this.handleClick(e)
        },
        cutoutPercentage: 25,
        legend: {
          display: true,
          position: 'top',
          labels: {
            fontColor: Vuetify.framework.theme.isDark ? 'white' : 'black'
          }
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          callbacks: {
            label: function(tooltipItems, data) { 
              let {datasetIndex, index} = tooltipItems
              return  data.labels[index]+ ': ' + data.datasets[datasetIndex].data[index] + ' inconformidades';
            },
          }
        },
        maintainAspectRatio: true,
        plugins: {
          colorschemes: {
            scheme: 'tableau.RedBlack7'
          },
          doughnutlabel: {
            labels: [
              {
                text: 'Total',
                font: {
                  size: '30',
                },
                color: Vuetify.framework.theme.isDark ? 'white' : 'black'
              },
              {
                text: null,
                font: {
                  size: '30'
                },
                color: Vuetify.framework.theme.isDark ? 'white' : 'black'
              },
            ]
          },
          datalabels: {
            align: 'center',
            anchor: 'center',
            // rotation: 90,
            color: function(ctx) {
              return 'white'
            },
            font: {
              weight: 'bold',
              size: 15
            },
            formatter: function(value, ctx) {
              let datasets = ctx.chart.data.datasets;

              if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                let sum = datasets[0].data.reduce((a, b) => a + b, 0);
                var percentage = Math.round((value / sum) * 100) + '%';
                return `${percentage? percentage : null}`;
              } else {
                return `${value} - ${percentage? percentage : null}`;
              }
              // return context.chart.data.labels[context.dataIndex] + value
            }
          }
        }
      },
      chart_ready: false,
      local_data: []
      // loading_dash: false,
    }
  },
  methods: {
    handleClick(e){
      try {
        let chart = this.$refs.ct._data._chart
        const activePoints = chart.getElementsAtEventForMode(e, 'nearest', {intersect: true})
        if(activePoints.length){
          const [{_index}] = activePoints;
          const value = this.$refs.ct._props.chartData.datasets[0].data[_index];
          const label = this.$refs.ct._props.chartData.labels[_index];
          this.$emit('chart_clicked', { _index, value, label, data: this.local_data[_index], kind: this.kind })
        }
      } catch (error) {
        console.log(error);
      }
    },
    loadChart2(){
      this.chart_ready = false
      this.DonutData.datasets[0].data = []
      this.DonutData.labels = []

      let data = this.data || []
      // auto-comment// console.log({dians: this.done_item.answers});
      
      // let colors = this.setColors(result[0].length)
// 
      // this.DonutData.datasets[0].backgroundColor = colors.backgroundColor
      // this.DonutData.datasets[0].borderColor = colors.borderColor
      // this.DonutData.datasets[0].hoverBackgroundColor = colors.hoverBackgroundColor
      
      this.DonutData.datasets[0].data = [...result[1]] //, ...result[1]]
      
      this.DonutData.labels = [...result[0]] //,...result[0]] // [...this.oneForm.items.map(ans => ans.title),...this.oneForm.items.map(ans => ans.title),...this.oneForm.items.map(ans => ans.title)]
      this.DonutOptions.plugins.doughnutlabel.labels[1].text = this.DonutData.datasets[0].data.reduce((a,b)=> a+b,0)

      setTimeout(() => {
        this.chart_ready = true
      }, 200);
    },
    loadChart(){
      this.chart_ready = false
      // this.chartData.datasets[1].data = [] 
      this.DonutData.datasets[0].data = []
      this.DonutData.labels = []

      let data = this.data//.filter(d=> d[this.text_key])
      data = [...data] //, ...data]

      data = data.sort((a, b) => a[this.value_key] < b[this.value_key]? 1 : -1 );
      this.local_data = data

      this.DonutData.datasets[0].data = [...data.slice(0,this.max_data).map(d => d[this.value_key])] // , ...this.oneForm.items.map(ans => ans.total_ok+2),...this.oneForm.items.map(ans => ans.total_ok+2)]
      // this.DonutData.datasets[1].data = [...this.oneForm.items.map(ans => -ans.total_nok)] //, ...this.oneForm.items.map(ans => -ans.total_nok-2),...this.oneForm.items.map(ans => -ans.total_nok-2)]
      this.DonutData.labels = [...data.slice(0,this.max_data).map(d => {
        // let label = d[this.text_key]
        // const etc = label.length > 20? '...':''
        return `${d[this.text_key].toUpperCase()}`
      })] //,...this.oneForm.items.map(ans => `${ans.title} - 2`),...this.oneForm.items.map(ans => `${ans.title} - 3`)]
      this.DonutOptions.plugins.doughnutlabel.labels[1].text = this.DonutData.datasets[0].data.reduce((a,b)=> a+b,0)

      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.loadChart();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv.length){
        this.loadChart()
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>